"use client";

import styled from "styled-components";

interface TextColor {
  $color: "red" | "green" | "blue";
}

interface BoxIconColorProps {
  $colorIcon: "red" | "green" | "blue" | "purple" | "yellow" | undefined;
}

interface ValueColor {
  $colorValue: "red" | "green" | "yellow" | "colorTitle" | "blue";
}

interface PercentColor {
  $colorPercent: "red" | "green";
}

export const BoxCard = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  background: var(--backgroundColorCard);
  padding: 1rem 1.25rem;
  border-radius: 0.75rem;
  border: 1px solid var(--borderColor);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: 100%;
  width: 100%;
  max-height: 100px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  @media (min-width: 768px) {
    gap: 15px;
    padding: 20px 25px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      var(--primarySystem100),
      var(--primarySystem)
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);

    &::before {
      opacity: 1;
    }
  }
`;

export const BoxContentCard = styled.div``;

export const Title = styled.h4`
  font-family: "Inter Medium";
  font-size: 11px;
  color: var(--textLight);
  margin-bottom: 3px;

  @media (min-width: 768px) {
    font-size: 12px;
  }
`;

export const Value = styled.h2<ValueColor>`
  font-family: "Roboto Regular";
  font-size: 18px;
  color: ${({ $colorValue }) => {
    switch ($colorValue) {
      case "red":
        return "var(--red)";
      case "green":
        return "var(--green)";
      case "yellow":
        return "var(--yellow)";
      case "blue":
        return "var(--blue)";
      case "colorTitle":
      default:
        return "var(--colorTitle)";
    }
  }};
  display: flex;
  align-items: end;
  gap: 8px;
  margin-bottom: 6px;
  line-height: 1.2;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    font-size: 22px;
    gap: 10px;
    margin-bottom: 8px;
    flex-wrap: nowrap;
  }
`;

export const TextColor = styled.span<TextColor>`
  font-weight: 600;
  font-size: 11px;
  color: ${({ $color }) =>
    $color == "red"
      ? `var(--red)`
      : $color == "blue"
        ? `var(--blue)`
        : `var(--green)`};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: fit-content;
  line-height: 1;
  margin-left: 8px;
`;

export const BoxIcon = styled.div<BoxIconColorProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: 10px;
  min-width: 40px;
  min-height: 40px;
  flex-shrink: 0;

  @media (min-width: 768px) {
    border-radius: 12px;
    padding: 12px;
    min-width: 48px;
    min-height: 48px;
  }

  background-color: ${({ $colorIcon }) => {
    switch ($colorIcon) {
      case "green":
        return "rgba(16, 185, 129, 0.1)";
      case "blue":
        return "rgba(59, 130, 246, 0.1)";
      case "yellow":
        return "rgba(245, 158, 11, 0.1)";
      case "purple":
        return "rgba(139, 92, 246, 0.1)";
      case "red":
        return "rgba(239, 68, 68, 0.1)";
      default:
        return "rgba(107, 114, 128, 0.1)";
    }
  }};

  svg {
    stroke: ${({ $colorIcon }) => {
      switch ($colorIcon) {
        case "green":
          return "#10b981";
        case "blue":
          return "#3b82f6";
        case "yellow":
          return "#f59e0b";
        case "purple":
          return "#8b5cf6";
        case "red":
          return "#ef4444";
        default:
          return "var(--primarySystem100)";
      }
    }};
    width: 20px;
    height: 20px;
    stroke-width: 2;

    @media (min-width: 768px) {
      width: 24px;
      height: 24px;
    }
  }
`;

export const PercentText = styled.span<PercentColor>`
  display: block;
  font-family: "Inter Regular";
  font-size: 11px;
  color: ${({ $colorPercent }) =>
    $colorPercent === "red" ? "var(--red)" : "var(--green)"};
`;
